import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { useAuth } from '@/shared/auth/useAuth'

export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) return <p className="page-state">Carregando…</p>
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />

  return <>{children}</>
}
